import { render } from "./WhatsAppPackagePurchaseModal.vue?vue&type=template&id=2f0ce4e4"
import script from "./WhatsAppPackagePurchaseModal.vue?vue&type=script&lang=js"
export * from "./WhatsAppPackagePurchaseModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__